import React, { Component } from "react";
import { Form, Row, Col, Modal } from "antd";
import { RightOutlined } from "@ant-design/icons";

import { CarInformation } from "./car-information/car-information";
import { CarLicense } from "./car-license/car-license";
import { CarOwner } from "./car-owner/car-owner";
import { CarManagement } from "./car-management/car-management";
import { BottomButton } from "./bottom-button/bottom-button";
import { submit, carConvert } from "./car-event";
import { apiVehicle } from "../../../api/api-vehicle";
import { alert } from "../../../common/utils/alert";

const layout = {
  labelCol: { span: 10 },
  wrapperCol: { span: 14 },
};
//Sử dụng Ref cho vấn đề cập nhật lại UI trong các Component con
export class AddCar extends Component {
  state = {
    enterprise: true,
    editable: true,
    editPage: false,
    typeOption: "create_new",
    carStatusType: "CDD",
    inactiveDelete: false,
  };

  carParam = [];

  async componentDidMount() {
    const carOptions = await apiVehicle.getCarOptions();
    if (carOptions.status === "success") {
      this.dataOptions = carOptions.data;
      this.setOptionState();
    }
  }

  setOptionState = () => {
    if (!this.dataOptions) {
      return;
    }
    const {
      branches,
      fuel_groups,
      supplier_groups,
      operation_admins,
      unit_operators,
      accountants,
    } = this.dataOptions;
    this.carOwner &&
      this.carOwner.setState({
        fuel_groups: fuel_groups.map((item) => {
          return { ...item, code: item.id };
        }),
        supplier_groups: supplier_groups.map((item) => {
          return { ...item, code: item.id };
        }),
        branches: branches.map((item) => {
          return { ...item, code: item.id, name: item.code };
        }),
      });
    // this.carManagement && this.carManagement.setState({
    //     operation_admins: operation_admins.map(item => { return { ...item, code: item.id } }),
    //     unit_operators: unit_operators.map(item => { return { ...item, code: item.id } }),
    //     accountants: accountants.map(item => { return { ...item, code: item.id } })
    // })
  };

  submit = async () => {
    submit(this);
  };

  deleteCar = () => {
    Modal.confirm({
      title: "Xóa xe",
      icon: null,
      content: "Bạn có chắc chắn muốn xóa xe này không?",
      okText: "Có",
      okType: "danger",
      cancelText: "Không",
      confirmLoading: this.state.confirmLoading,
      onOk: async () => {
        this.setState({ confirmLoading: true });

        apiVehicle
          .deleteCar(this.state.carIdEdit)
          .then((response) => {
            this.setState({ confirmLoading: false });
            if (response.status === "success") {
              alert("success", "Xóa xe thành công!");
              this.props.close();
            } else {
              alert("error", response.data.message);
            }
          })
          .catch((err) => {
            this.setState({ confirmLoading: false });
          });
      },
      onCancel() {},
      className: "del-comfirm",
    });
  };

  onChangeForm = (feild, value) => {
    this.form &&
      this.form.setFieldsValue({
        [feild]: value,
      });
  };
  setCarStatusType = (carStatusType) => {
    this.setState({ carStatusType });
  };

  onChangeFormValues = (values) => {
    this.form.setFieldsValue({
      ...values,
    });
  };

  goToCarDetail = () => {
    if (this.carParam) this.updateFormCar(this.carParam);
  };

  updateFormCar = (car) => {
    if (car.owner === "AVIS") {
      this.carOwner.setState({ isAvisCar: true });
    }
    if (car.in_contract) {
      this.setState({
        inactiveDelete: true,
      });
    }
    this.carParam = car;
    this.setState({
      editable: false,
      typeOption: "show_detail",
      editPage: true,
      carIdEdit: car.id,
    });
    this.carManagement &&
      this.carManagement.setState({
        in_current_journey_diary: car.current_journey_diary_id ? true : false,
        in_current_contract: car.current_contract_id ? true : false,
        carStatus: car.status,
      });
    carConvert(car, this);
  };

  enableEdit = () => {
    this.setState({ editable: true, typeOption: "edit" });
  };

  cancelEdit = () => {
    this.setState({ editable: false, typeOption: "show_detail" });
  };

  render() {
    const { typeOption, editable, editPage, inactiveDelete } = this.state;
    return (
      <div className="add-car">
        <div className="add-new-car-title">
          <span onClick={this.props.close}>
            Danh sách xe
            <RightOutlined style={{ margin: "0px 7px" }} />
          </span>
          {typeOption === "create_new"
            ? "Thêm xe mới"
            : typeOption === "show_detail"
            ? "Chi tiết xe"
            : "Chỉnh sửa xe"}
        </div>
        <Form
          style={{ padding: "0px 10px" }}
          initialValues={{
            classify_car: "MT",
            car_status: "CDD",
            fuel_type_code: "",
            car_resource: "",
            area_management: "",
            operation_admin: "",
            unit_operator: "",
            accountant: "",
          }}
          scrollToFirstError
          ref={(ref) => (this.form = ref)}
          {...layout}
        >
          <Row gutter={24}>
            <Col xs={24} sm={24} md={12} lg={12}>
              <CarInformation
                editable={editable}
                editPage={editPage}
                onChangeForm={this.onChangeForm}
                ref={(ref) => (this.carInfo = ref)}
              />
              <CarLicense
                editable={editable}
                ref={(ref) => (this.carLicense = ref)}
              />
            </Col>
            <Col xs={24} sm={24} md={12} lg={12}>
              <CarOwner
                editable={editable}
                ref={(ref) => (this.carOwner = ref)}
                onChangeForm={this.onChangeForm}
              />
              <CarManagement
                editPage={editPage}
                editable={editable}
                typeOption={typeOption}
                ref={(ref) => (this.carManagement = ref)}
                onChangeForm={this.onChangeForm}
                onChangeFormValues={this.onChangeFormValues}
              />
            </Col>
          </Row>
        </Form>
        <BottomButton
          typeOption={typeOption}
          enableEdit={this.enableEdit}
          submit={this.submit}
          cancelEdit={this.cancelEdit}
          close={this.props.close}
          deleteCar={this.deleteCar}
          inactiveDelete={inactiveDelete}
          goToDetailCar={this.goToDetailCar}
          carParam={this.carParam}
        />
      </div>
    );
  }
}
